<template>
  <div class="confirmation-delay">
    <span class="card-label">Confirmação de recebimento</span>
    <p v-if="loading" class="state-message">Calculando recebimentos...</p>
    <p v-else-if="error" class="state-message error">{{ error }} <button class="retry-button" @click="load">Tentar novamente</button></p>
    <template v-else>
      <strong class="card-value">{{ result?.median_minutes == null ? '—' : `${result.median_minutes} min` }}</strong>
      <span class="card-detail">Tempo mediano até a primeira confirmação</span>
      <span class="card-detail">{{ result?.sample_count || 0 }} confirmações consideradas</span>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import { config } from "../../config";

export default {
  name: "ConfirmationDelayPanel",
  props: {
    from: { type: String, default: null },
    to: { type: String, default: null },
    businessClient: { type: String, default: null },
  },
  data() { return { result: null, loading: false, error: null, requestId: 0 }; },
  computed: { queryKey() { return `${this.from}|${this.to}|${this.businessClient || ''}`; } },
  watch: { queryKey: { immediate: true, handler() { this.load(); } } },
  methods: {
    async load() {
      const id = ++this.requestId;
      if (!this.from || !this.to) { this.result = null; return; }
      this.loading = true;
      this.error = null;
      try {
        const params = { from: this.from, to: this.to };
        if (this.businessClient) params.business_client = this.businessClient;
        const { data } = await axios.get(`${config.API}/v1/metrics/confirmation-delay`, { params });
        if (id === this.requestId) this.result = data;
      } catch (error) {
        if (id !== this.requestId) return;
        this.result = null;
        this.error = error?.response?.data?.detail || "Não foi possível calcular o tempo até confirmação.";
      } finally { if (id === this.requestId) this.loading = false; }
    },
  },
};
</script>

<style scoped>
.confirmation-delay { flex: 1 1 200px; display: flex; flex-direction: column; gap: 6px; min-width: 0; padding: 18px 20px; border: 1px solid #e6edf5; border-radius: 12px; background: #fff; font-family: "Globo-Regular", sans-serif; color: #2b4054; }
.card-label { font-size: 14px; color: #6f7b87; }
.card-value { font-size: 32px; font-family: "Globo-Bold", sans-serif; color: #2b4054; }
.card-detail, .state-message { margin: 0; font-size: 12px; line-height: 1.4; color: #6f7b87; }
.error { color: #e15757; }
.retry-button { padding: 0; border: 0; background: transparent; color: #3a6d8c; font: inherit; text-decoration: underline; cursor: pointer; }
</style>
